// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import DatatableFactory from 'vuejs-datatable';
import VueSession from 'vue-session';
//import Paginate from 'vuejs-paginate';

// import { routes } from '@/router'; 
import store from '@/components/store';
import GlobalComponents from '@/components/globalComp'
import ElementUI from 'element-ui'

// Import the el's from the chalk 

import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueCurrencyFilter from 'vue-currency-filter'

/*import { DataTables, DataTablesServer } from 'vue-data-tables'
Vue.use(DataTables)
Vue.use(DataTablesServer)*/

// import DataTables and DataTablesServer together
/*import VueDataTables from 'vue-data-tables'
Vue.use(VueDataTables)*/

Vue.use(DatatableFactory);

Vue.use(ElementUI, { locale })
Vue.use(GlobalComponents)

//Vue.component('paginate', Paginate)
Vue.config.productionTip = false

Vue.use(VueCurrencyFilter,
  {
    symbol : '₦',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
  })




require('@/assets/css/bootready.css')
// require('@/assets/bootstrap/css/bootstrap.css')

require('@/assets/css/adminlte.css')
require('@/assets/css/animate.css')
require('@/assets/css/ionicons.min.css')
require('@/assets/css/normalize.css')
require('@/assets/js/adminlte.min.js')
require('@/assets/css/font-awesome.min.css')

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueSession);
// const router = new VueRouter({
//   routes: routes,
//   mode: 'history'

// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js